// Mensagens trocadas entre a Mini App e o servidor (JSON pelo WebSocket em /ws).
// Só tipos: cliente e servidor importam com `import type`.

export type Facing = 'down' | 'up' | 'left' | 'right';
export type Scene = 'overworld' | 'battle' | 'other';

/** Onde o jogador está e o que está fazendo, lido da RAM do jogo. */
export interface Presence {
  /** [mapGroup, mapNum] */
  map: [number, number];
  /** Tile dentro do mapa. */
  x: number;
  y: number;
  facing: Facing;
  moving: boolean;
  /** Correndo (tênis) ou de bicicleta: o passo dura menos. */
  fast: boolean;
  gender: 0 | 1;
  scene: Scene;
  /** Nome do treinador no jogo (aparece na cabeça do personagem). */
  nick: string;
  /** Espécie do Pokémon que segue o jogador (0 = nenhum). */
  lead: number;
}

export interface PlayerInfo {
  id: number;
  name: string;
  pos: Presence | null;
}

export interface ChatMessage {
  id: number;
  userId: number;
  name: string;
  text: string;
  /** Unix epoch em milissegundos. */
  at: number;
}

export const CHAT_MAX_LENGTH = 300;
export const CHAT_PAGE_SIZE = 50;

/** Inicial escolhido no cadastro (ordem do `VAR_STARTER_MON`: 0 BULBASAUR, 1 SQUIRTLE, 2 CHARMANDER). */
export type Starter = 0 | 1 | 2;

export type ClientMessage =
  | { t: 'hello'; initData?: string; guestName?: string; room?: string }
  | { t: 'pos'; pos: Presence }
  | { t: 'chat'; text: string }
  | { t: 'history'; before: number }
  /** Acabou de criar o jogo neste aparelho (o servidor avisa a turma). */
  | { t: 'newgame'; nick: string; starter: Starter | null };

export type ServerMessage =
  | {
      t: 'welcome';
      you: { id: number; name: string };
      room: string;
      players: PlayerInfo[];
      history: ChatMessage[];
      hasMore: boolean;
    }
  | { t: 'join'; player: PlayerInfo }
  | { t: 'leave'; id: number }
  | { t: 'pos'; id: number; pos: Presence }
  | { t: 'chat'; message: ChatMessage }
  | { t: 'history'; messages: ChatMessage[]; hasMore: boolean }
  | { t: 'notice'; text: string };

/** Códigos de fechamento do WebSocket usados pelo servidor. */
export const CloseCode = {
  /** initData inválido ou expirado: reabrir a Mini App. */
  Unauthorized: 4001,
  /** A mesma conta conectou em outro aparelho/aba. */
  Replaced: 4002,
  /** Não mandou o "hello" a tempo. */
  HelloTimeout: 4003,
  /** Conta do Telegram ainda não liberada por um admin. */
  NotAllowed: 4004,
} as const;
